import * as Checkbox from './checkbox'
import * as Input from './input'
import * as Radio from './radio'
import * as Select from './select'
import * as Textarea from './textarea'

const element_reducers = {
  checkbox: Checkbox,
  input: Input,
  radio: Radio,
  select: Select,
  textarea: Textarea,
}

const initalStateAnswerPageElement = page_element =>
  element_reducers[page_element.question_type].initialState(page_element)

const newAnswerPageElement = (element, payload, attempt, step) =>
  element_reducers[element.question_type].answerUpdate(element, payload, attempt, step)

export const initialState = (page = { page_elements: [] }) => ({
  page_elements: page.page_elements.filter(
    page_element => element_reducers[page_element.question_type],
  ).map(page_element => ({
    question_type: page_element.question_type,
    ...initalStateAnswerPageElement(page_element),
  })),
})

export const answerUpdate = (state = initialState(), payload, attempt, step) => ({
  ...state,
  page_elements: state.page_elements.map(answerPageElement =>
    newAnswerPageElement(answerPageElement, payload, attempt, step),
  ),
})

export default { initialState, answerUpdate }



// WEBPACK FOOTER //
// ./src/reducers/Missions/Answers/Form/index.jsx